<span class="weissman-datetime-picker">
    @if (!readOnly) {
        <div #dtDateInput class="input-group flex-nowrap" [ngStyle]="{ width: fillWidth ? '100%' : null }">
            <input
                type="text"
                class="weiss-datepicker-input form-control exclude-modal-styling"
                helpTooltip
                [helpContentId]="helpContentId"
                position="bottom"
                autocomplete="nope"
                [ngClass]="className"
                [class.invalid]="isInvalid || setInvalid"
                [class.overridden]="isOverridden"
                [class.ng-touched]="setAsTouched"
                [class.ng-invalid]="(required && !inputDate) || setInvalid"
                [disabled]="isDisabled"
                [required]="required"
                (blur)="onBlur()"
            />
            @if (!isDisabled) {
                <button type="button" class="ace-btn btn-secondary has-icon" (click)="openDatepicker()">
                    <i class="fa fa-calendar"></i>
                </button>
            }
            @if (!readOnly && !dateOnly) {
                <input
                    #dtTimeInput
                    type="text"
                    class="weiss-datepicker-time-input form-control exclude-modal-styling d-inline-block"
                    [class.invalid]="isInvalid"
                    [class.overridden]="isOverridden"
                    [(ngModel)]="internalTime"
                    [disabled]="isDisabled"
                    placeholder="--:-- --"
                />
            }
        </div>
    }

    @if (readOnly) {
        <span>{{ displayDate }}</span>
    }
</span>
